export default __webpack_public_path__ + "static/img-ef-8-9ebb806ce3f61e0f8011d09e779f6ee6.png";